export const TimePickerConstants = {
  TIMEPICKER_SET_DATE: 'TIMEPICKER_SET_DATE',
};
